const { createContext } = require("react");

export const themeContext = createContext();
